<template>
  <div>
    <div v-if="!isLoggedIn">
      <h1 class="mb-2">Registrierung</h1>
        <div v-if="userFeedback" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-4" role="alert">
          <p v-html="userFeedback"></p>
        </div>

        <form v-on:submit.prevent="userRegistrationAction()" class="max-w-md flex flex-wrap">
          <label class="block mt-4 w-full md:w-1/2 md:pr-1 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-register-firstname">
            Dein Vorname
            <input v-model="loginData.item_firstname" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-register-firstname" type="text" autocomplete="given-name" placeholder="Vorname" />
          </label>
          <label class="block mt-4 w-full md:w-1/2 md:pl-1 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-register-lastname">
            Dein Nachname
            <input v-model="loginData.item_lastname" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-register-lastname" type="text" autocomplete="family-name" placeholder="Nachname" />
          </label>
          <label class="block mt-4 w-full uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-register-mail">
            Deine E-Mail Adresse
            <input v-model="loginData.item_email" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-register-mail" type="email" autocomplete="email" placeholder="E-Mail Adresse" />
          </label>
          <label class="block mt-4 w-full uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-register-phone">
            Deine Handynummer
            <input v-model="loginData.item_phone" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-register-phone" type="text" autocomplete="tel" placeholder="Handynummer" />
          </label>
          <label class="block mt-4 w-full uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-register-passwd">
            Dein Passwort
            <input v-model="loginData.item_password" required minlength="8" class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-register-passwd" type="password" autocomplete="off" placeholder="" />
          </label>
          <input type="submit" class="block w-full mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black mt-2 py-2 px-4 rounded" value="kostenlos registrieren" />
        </form>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'userRegistration',

  data () {
    return {
      loginData: {
        item_firstname: '',
        item_lastname: '',
        item_email: '',
        item_phone: '',
        item_password: ''
      }
    }
  },

  computed: {
    ...mapGetters([
      'isLoggedIn',
      'userFeedback'
    ])
  },

  created () {
    this.getLastOrder()
  },

  mounted () {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'Einstellungen' })
    }
  },

  watch: {
    isLoggedIn: function () {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'Einstellungen' })
      }
    }
  },

  methods: {
    ...mapActions([
      'userRegistration'
    ]),

    getLastOrder () {
      axios.post(endpoints.lastOrder)
        .then(({ data }) => {
          if (data) {
            this.loginData.item_firstname = data.order.firstname
            this.loginData.item_lastname = data.order.lastname
            this.loginData.item_email = data.order.email
            this.loginData.item_phone = data.order.mobile
          }
        })
    },

    userRegistrationAction () {
      this.userRegistration(this.loginData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/registration.vue